module.exports = __webpack_public_path__ + "static/footer_image-8c88b3015189d39c9ed7df71bbab2e85.jpg";